import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { AppFacadeService } from '../../services/app-facade.service';
import { DocumentData } from '../../store/domains/document/document.reducers';
import { Subscription } from 'rxjs';
import { GetDocumentParam } from '../../models/contract-model';
import { VersionToggleService } from '../../services/version-toggle';
import { DocumentConfig } from '../../models/document-config.model';

@Component({
    standalone: false,
    selector: 'por-document-lists',
    templateUrl: './document-lists.component.html',
    styleUrls: ['./document-lists.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentListsComponent implements OnInit, OnDestroy {
    readonly appFacadeService = inject(AppFacadeService);
    readonly versionToggleService = inject(VersionToggleService);

    @Input() uiUrl!: string;
    subscriptions: Subscription[] = [];

    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input({ required: true }) documentParams!: GetDocumentParam;

    documentConfigs: Array<DocumentConfig> = [
        {
            documentType: 'InspectionCertificate',
            label: 'InspectionCertifications',
            featureToken: ['displayInspectionDocument'],
            featureName: 'inspection-certificate-btn',
            imgUrl: 'inspection-certificate-150245.svg'
        },
        {
            documentType: 'ServiceCertificate',
            label: 'ServiceCertificates',
            featureToken: ['displayServiceCertificate'],
            featureName: 'service-certificate-btn',
            imgUrl: 'service-certificate-3504413.svg'
        },
        {
            documentType: 'SafetyInstruction',
            label: 'instructions',
            featureToken: undefined,
            featureName: 'instructions-btn',
            imgUrl: 'instructions.svg'
        }
    ];
    ngOnInit(): void {
        // If there's no contractId, prepend 'Stock' to document types as this is a Syrinx Stock QuickLink scenario
        if (this.documentParams.contractId?.trim().length === 0) {
            this.documentConfigs = this.documentConfigs.map(config => ({
                ...config,
                documentType: `Stock${config.documentType}`
            }));
        }
        this.appFacadeService.loadDocuments(this.documentParams);
    }

    ngOnDestroy(): void {
        this.subscriptions.map((sub: Subscription) => sub.unsubscribe());
        this.appFacadeService.cancelLoadDocuments();
        this.appFacadeService.emptyDocument();
    }
    openDocumentUrl(documentType: string): void {
        this.subscriptions.push(
            this.appFacadeService.openPdfdocument(documentType).subscribe((response: DocumentData[]) => {
                if (response.length > 0) {
                    this.appFacadeService.pdf.openPdfinNewTab(response[0].url);
                }
            })
        );
    }
}
